module.exports = __webpack_public_path__ + "img/4.440f7469.png";